import React from 'react'
import Img from 'gatsby-image'

import MainSectionLayout from '@/main-section-layout'
import GetStartedButton from '@/get-started-button'
import PageTopBar from '@/page-top-bar'
import LargeText from '@/large-text'

import './styles.css'

const SectionWhoWeAre = ({ data }) => {
  return (
    <PageTopBar iconName="masks" text="Who we are">
      <MainSectionLayout
        noLogo
        title="Who we are"
        about="We are a team of experts in digital turnkey solutions for beauty pageants"
      >
        <div className="mw540 center mb6 bg-logo">
          <LargeText>
            Next Miss is the recognised leader in enabling beauty pageants to reach their next level. Our talented people operate with high energy to unleash our collective entrepreneurial potential to deliver great things for our clients.
          </LargeText>

          <LargeText>
            We have great clients who largely come to us via referral, making our reputation our most valuable asset. We take pride in what we do and over the past years have been honoured to be part of some amazing success cases, contributing to the success of our clients and our own growing Next Miss team.
          </LargeText>
        </div>

        <div className="mb7">
          <GetStartedButton />
        </div>

        <div className="flex flex-wrap">
          <Block title="Our vision" bgImage={data.ourValuesBg.sizes}>
            <LargeText mb4>
              To be leading partner in shaping the future of beauty pageant industry.
            </LargeText>

            <LargeText mb4>
              To be known as a brilliant place to work.
            </LargeText>

            <LargeText mb4>
              To be a thriving business that promotes innovation and entrepreneurship.
            </LargeText>
          </Block>

          <Block title="Our values" bgImage={data.ourVisionBg.sizes}>
            <LargeText mb4>
              Next Miss people are Awesome Together.
            </LargeText>

            <LargeText mb4>
              We work with High Energy and Absolute Integrity.
            </LargeText>

            <LargeText mb4>
              We Celebrate Simplicity and have a Relentless Commitment to get the right results for our clients, and each other.
            </LargeText>
          </Block>
        </div>
      </MainSectionLayout>
    </PageTopBar>
  )
}

function Block({ title, children, bgImage }) {
  return (
    <div className="w-100 w-50-m ph2 mb3 mb0-m who-we-are-block">
      <div className="br3 white ph3 pv4 pa5-l h-100 relative">
        <div className="z-1 absolute absolute--fill">
          <Img sizes={bgImage} alt="" className="h-100 w-100 br3" />
        </div>

        <div className="relative z-2">
          <h6 className="f6 mt0 mb4 tc">{title}</h6>
          <div className="">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionWhoWeAre



// WEBPACK FOOTER //
// ./src/components/section-who-we-are/section-who-we-are.js